module.exports = __webpack_public_path__ + "static/media/human-robot-hands.b07328db.svg";